/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.filter('authorizeUserFilter', () => (function(groups, roles) {
    for (let role of Array.from(roles)) {
        if (-1 !== groups.indexOf(role)) { return true; }
    }
    return false;
}));

